var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FAF9F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 20.3335C28.9435 20.3335 26.4585 22.8185 26.4585 25.8752C26.4585 28.8735 28.8035 31.3002 31.8602 31.4052C31.9535 31.3935 32.0468 31.3935 32.1168 31.4052C32.1402 31.4052 32.1518 31.4052 32.1752 31.4052C32.1868 31.4052 32.1868 31.4052 32.1985 31.4052C35.1852 31.3002 37.5302 28.8735 37.5418 25.8752C37.5418 22.8185 35.0568 20.3335 32.0002 20.3335Z",
    fill: "#908880"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9266 34.5084C34.6716 32.3384 29.3633 32.3384 26.085 34.5084C24.6033 35.5 23.7866 36.8417 23.7866 38.2767C23.7866 39.7117 24.6033 41.0417 26.0733 42.0217C27.7066 43.1184 29.8533 43.6667 32 43.6667C34.1466 43.6667 36.2933 43.1184 37.9266 42.0217C39.3966 41.03 40.2133 39.7 40.2133 38.2534C40.2016 36.8184 39.3966 35.4884 37.9266 34.5084Z",
    fill: "#908880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhoto);
export default __webpack_public_path__ + "static/media/user-photo.276faa058a8052cd9be8a26f34fd4c65.svg";
export { ForwardRef as ReactComponent };